import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cireApiBaseUrl = environment.config.CIRE_SERVICE_URL;
  const isCireRequest = req.url.startsWith(cireApiBaseUrl);
  if (isCireRequest) {
    let headers = req.headers;
    if (req.body instanceof FormData) {
      headers = headers.set('enctype', 'multipart/form-data');
    } else {
      if (!req.headers.has('Content-Type')) {
        headers = headers.set('Content-Type', 'application/json');
      }
    }
    const modifiedReq = req.clone({ headers });
    return next(modifiedReq);
  }

  return next(req);
};
